// Design tokens da tela de Calendários.
// Referência: .md/DESIGN_UIUX.md (Painel de Configurações).

export const CALENDARIOS_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',

  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',

  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  stack: 'flex flex-col gap-3.5',
  grid: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0 flex flex-col',
  cardTitle: 'text-[15px] font-semibold text-[#18181b] truncate',
  cardMeta: 'mt-1 text-[13px] text-[#71717a]',

  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  dangerButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#b42318] whitespace-nowrap transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca] disabled:opacity-50 disabled:cursor-not-allowed',

  field: 'min-w-0',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',

  choiceGrid: 'grid grid-cols-1 md:grid-cols-2 gap-2.5',
  choiceCard: 'text-left px-3.5 py-[13px] rounded-lg border transition-colors cursor-pointer',
  choiceCardOn: 'bg-[#ede9fe] border-[#a78bfa]',
  choiceCardOff: 'bg-white border-[#e7e7ec] hover:border-[#d4d4d8]',
  choiceTitle: 'text-[13.5px] font-semibold',
  choiceTitleOn: 'text-[#5b21b6]',
  choiceTitleOff: 'text-[#18181b]',
  choiceHelp: 'mt-[3px] text-[12px] text-[#71717a] leading-[1.45]',

  emptyWrap: 'px-2 py-10 text-center',
  emptyIcon:
    'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',

  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  dialogDesc: 'text-[13px] text-[#71717a] leading-[1.5]',
  dialogFooter: 'flex justify-end gap-2.5',

  badge: 'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap flex-shrink-0 border bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
};

export default CALENDARIOS_DESIGN;
